import { jsx as o, jsxs as d } from "react/jsx-runtime";
import { Icon as t } from "../../../../components/Icon/index.js";
import { IncompleteStarContainer as m } from "./style.js";
import { Star as a, StarSolid as e } from "@pelando/fontawesome/icons";
const f = ({ fillRate: r, className: i, ...n }) => Number.isInteger(r) ? /* @__PURE__ */ o(
  "div",
  {
    className: i,
    "data-fill-rate": r.toFixed(1),
    ...n,
    children: /* @__PURE__ */ o(
      t,
      {
        icon: r === 0 ? a : e,
        "data-fill-rate": r
      }
    )
  }
) : /* @__PURE__ */ d(
  m,
  {
    $fillRate: r,
    "data-fill-rate": r.toFixed(1),
    className: i,
    ...n,
    children: [
      /* @__PURE__ */ o(t, { icon: e }),
      /* @__PURE__ */ o(t, { icon: a })
    ]
  }
);
export {
  f as Star
};
